import { IManager, Manager, Config } from '../../core/Manager';
import { IToast, Toast } from '../../core/Toast';
import { ToastType } from '../../constants';

export const manager: IManager<IToast> = new Manager();

export type Notification = {
  title?: string;
  message: string;
};

export const getNotifyActionsMap = () => {
  return Object.values(ToastType).reduce((acc, type) => {
    return {
      ...acc,
      [type]: ({ title, message }: Notification, config: Config) =>
        manager.notify(new Toast(type, message, title), config),
    };
  }, {});
};

export const notify = getNotifyActionsMap();
